var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"btnCustom btnCustom-md btnCustom__warning-outline",attrs:{"title":_vm.data_title}},[_vm._v("\n    "+_vm._s(_vm.data_name)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }